import lodash from 'lodash';

export default {
  namespaced: true,
  state: {
    userData: null,
    currentApp: null,
    userPermissions: [],
  },
  getters: {
    getUserData: state => {
      return state.userData;
    },
    getUserPermissions: state => {
      return state.userPermissions;
    },
  },
  mutations: {
    setUserData(state, userData) {
      if (userData.permissions && userData.permissions !== '') {
        permissions = lodash.clone(userData.permissions);
        state.userPermissions = userData.permissions;
      } else {
        state.userPermissions = [];
      }
      delete userData.permissions;

      state.userData = userData;
    },
    setCurrentApp(state, currentApp) {
      state.currentApp = currentApp;
    },
  },
  actions: {},
}
